import styled from 'styled-components'
const StyledQCTable = styled.table`
  width: 100%;
  border-spacing: 0.5rem 1rem;
  border: solid 0.06rem black;
  border-collapse: collapse;
  margin-top: 0.25rem;

  @media (max-width: 48rem) {
    border-spacing: 0.12rem 0.18rem;
    margin: 0.25rem 0rem;
  }
`

const StyledRowHeading = styled.th`
  border: solid 0.06rem black;
  padding: 0.25rem 0.12rem;
  font-size: 0.5rem;
  min-width:2.58rem;
  @media (min-width: 480px) {
    padding: 0.5rem 0.25em;
    font-size: 0.8rem;
     min-width:3.25rem;
  }
`


const StyledRowColumn = styled.td`
  margin: 0.5rem;
  text-align: center;
  max-width: 11.9rem;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  border: solid 0.06rem black;
  padding: 0.5rem 0.12rem;
  font-size: 0.7rem;
  word-wrap: break-word;
  overflow: hidden;
  height: auto;
  @media (max-width: 48rem) {
    padding: 0.12rem 0.12rem;
    max-width: 8.12rem;
    font-size: 0.5rem;
  }
`
export { StyledQCTable, StyledRowHeading, StyledRowColumn }
